export default __webpack_public_path__ + "static/media/portfolio-v2.75f6be35.png";